// ════════════════════════════════════════════════════════════════════
// FORMATTERS — currency-aware number/percent formatting + pos/neg colors.
// CURRENT_CURRENCY is a module-level singleton set via setGlobalCurrency
// when the active workspace changes. Extracted verbatim from App.js.
// ════════════════════════════════════════════════════════════════════
import { C } from "./theme";

// Module-level currency — set when workspace changes
let CURRENT_CURRENCY = "GBP";
export const setGlobalCurrency = (c) => { CURRENT_CURRENCY = c; };
export const curSym = () => CURRENT_CURRENCY === "AED" ? "AED " : CURRENT_CURRENCY === "USD" ? "$" : CURRENT_CURRENCY === "INR" ? "₹" : "£";
export const fmt  = n => typeof n==="number"&&isFinite(n) ? `${curSym()}${n.toLocaleString("en-GB",{minimumFractionDigits:2,maximumFractionDigits:2})}` : "—";
export const fmtK = n => typeof n==="number"&&isFinite(n) ? (Math.abs(n)>=1000?`${curSym()}${(n/1000).toFixed(1)}k`:`${curSym()}${n.toFixed(0)}`) : "—";
export const pct  = n => typeof n==="number"&&isFinite(n) ? `${(n*100).toFixed(2)}%` : "—";
export const pctR = n => typeof n==="number"&&isFinite(n) ? `${(n*100).toFixed(1)}%` : "—";
export const posc = n => n >= 0 ? C.green : C.red;
export const posbg= n => n >= 0 ? C.green10 : C.red10;
